import React from "react";
import classNames from "classnames/bind";

import styles from "./Title.module.css";

const cx = classNames.bind(styles);

export const Title: React.FC<{}> = (props) => (
  <h1 className={cx("title")}>{props.children}</h1>
);
